import { gql, TypedDocumentNode } from '@apollo/client';

import { ChartIntervalEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { HistoryPeriodEnumKeys, RealFiatAssets } from '@libs/types';

import { CurrencyType } from 'src/constants';

type UserPNLChartData = {
  createdAt?: Date | string;
  amount: number | string;
};

export type IntervalPNLData = {
  endDate?: Date | string;
  amount: number | string;
  startDate?: Date | string;
};
export type GetUserPnlChartsArgs = {
  assetCode?: CurrencyType;
  interval: ChartIntervalEnum;
  valueAssetCode: RealFiatAssets;
  range: HistoryPeriodEnumKeys;
};

type GetUserPnlChartsData = {
  cumulativePNL: UserPNLChartData[];
  intervalPNL: IntervalPNLData[];
  interval: ChartIntervalEnum;
};

export type GetUserPnlChartsDataRes = {
  getUserPNLCharts: DefaultApiResponse<GetUserPnlChartsData>;
};

export const getUserPNLChartsQuery: TypedDocumentNode<
  GetUserPnlChartsDataRes,
  DefaultArg<GetUserPnlChartsArgs>
> = gql`
  query GetUserPNLCharts($record: GetUserPnlChartsRecord!) {
    getUserPNLCharts(record: $record) {
      cumulativePNL {
        createdAt: date
        amount: pnl
      }
      intervalPNL {
        startDate
        amount: pnl
        endDate
      }
      interval
    }
  }
`;
